import { Plus, ShoppingBag, Send, RotateCcw, AlertTriangle, Recycle, UserCheck, Camera, Trash2, Search } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

export const BOARD_TYPES = ['Shortboard', 'Longboard', 'Funboard', 'Fish', 'Gun', 'Foamie', 'SUP', 'Mid-length', 'Hybrid', 'Other'];
export const CONDITIONS = ['New', 'Good', 'Fair', 'Thrashed'];

export const STATUS_STYLES = {
  active: { label: 'Active', color: 'text-green-400 bg-green-400/10 border-green-400/20' },
  lent: { label: 'Lent Out', color: 'text-yellow-400 bg-yellow-400/10 border-yellow-400/20' },
  sold: { label: 'Sold', color: 'text-blue-400 bg-blue-400/10 border-blue-400/20' },
  lost: { label: 'Lost', color: 'text-red-400 bg-red-400/10 border-red-400/20' },
  found: { label: 'Found', color: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20' },
  recycled: { label: 'Recycled', color: 'text-purple-400 bg-purple-400/10 border-purple-400/20' },
  gifted: { label: 'Gifted', color: 'text-pink-400 bg-pink-400/10 border-pink-400/20' },
  deleted: { label: 'Deleted', color: 'text-gray-400 bg-gray-400/10 border-gray-400/20' },
};

export const EVENT_ICONS = {
  registered: { icon: Plus, color: 'text-green-400', bg: 'bg-green-400/15' },
  sold: { icon: ShoppingBag, color: 'text-blue-400', bg: 'bg-blue-400/15' },
  lent: { icon: Send, color: 'text-yellow-400', bg: 'bg-yellow-400/15' },
  gifted: { icon: UserCheck, color: 'text-pink-400', bg: 'bg-pink-400/15' },
  returned: { icon: RotateCcw, color: 'text-green-400', bg: 'bg-green-400/15' },
  lost: { icon: AlertTriangle, color: 'text-red-400', bg: 'bg-red-400/15' },
  found: { icon: Search, color: 'text-emerald-400', bg: 'bg-emerald-400/15' },
  recycled: { icon: Recycle, color: 'text-purple-400', bg: 'bg-purple-400/15' },
  deleted: { icon: Trash2, color: 'text-gray-400', bg: 'bg-gray-400/15' },
  photo_verified: { icon: Camera, color: 'text-secondary', bg: 'bg-secondary/15' },
};

export const CONDITION_COLORS = {
  'New': 'text-green-400 bg-green-400/10',
  'Good': 'text-primary bg-primary/10',
  'Fair': 'text-yellow-400 bg-yellow-400/10',
  'Thrashed': 'text-red-400 bg-red-400/10',
};

export function formatDate(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatTime(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}
